export default __webpack_public_path__ + "5c0c1045fe1bf2635ab2de7b7ca24351.jpg";